import React from 'react';
import MetaTags from 'react-meta-tags';
import { Container } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';

export const PageWrapper = ({ title, children }) => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>
          {title} | {process.env.REACT_APP_TITLE}
        </title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={title} />

          {children}
        </Container>
      </div>
    </React.Fragment>
  );
};
